import _ from "lodash";

export function sortReducer(state, action) {

  switch (action.type) {
    case "CHANGE_SORT":
      if (state.column === action.column) {
        return {
          ...state,
          data: [...state.data].reverse(),
          direction:
            state.direction === "ascending" ? "descending" : "ascending",
        };
      } else {
        return {
          column: action.column,
          data: _.sortBy(state.data, [action.column]),
          direction: "ascending",
        };
      }

    default:
      return {
        column: "",
        data: action.payload,
        direction: "",
      };
  }
}

